export interface Hotspot {
  name: string;
  lat: number;
  lon: number;
}

export const HOTSPOTS: Hotspot[] = [
  { name: "Tel Aviv", lat: 32.08, lon: 34.78 },
  { name: "London", lat: 51.5, lon: -0.12 },
  { name: "New York", lat: 40.71, lon: -74.01 },
  { name: "Berlin", lat: 52.52, lon: 13.4 },
  { name: "Istanbul", lat: 41.01, lon: 28.98 },
  { name: "Moscow", lat: 55.75, lon: 37.62 },
  { name: "Mumbai", lat: 19.07, lon: 72.88 },
  { name: "Tokyo", lat: 35.68, lon: 139.69 },
  { name: "Singapore", lat: 1.35, lon: 103.82 },
  { name: "São Paulo", lat: -23.55, lon: -46.63 },
  { name: "Johannesburg", lat: -26.2, lon: 28.05 },
  { name: "Sydney", lat: -33.87, lon: 151.21 },
];
